/**
 * @generated SignedSource<<1d6e2b2b764845891ac80d081ba46535>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type composerQueriesImagesMacroQueriesCategories_fragment$data = {
  readonly imageMacroCategories: ReadonlyArray<{
    readonly categories: ReadonlyArray<{
      readonly categoryPosition: number;
      readonly hasImages: boolean;
      readonly id: string;
      readonly isSystemwide: boolean;
      readonly name: string;
      readonly numberOfProducts: number;
      readonly referenceKey: string | null;
    }>;
    readonly hasImages: boolean;
    readonly id: string;
    readonly isSystemwide: boolean;
    readonly macroCategoryPosition: number;
    readonly name: string;
    readonly numberOfProducts: number;
    readonly onlyForBackgrounds: boolean;
    readonly referenceKey: string | null;
  }>;
  readonly " $fragmentType": "composerQueriesImagesMacroQueriesCategories_fragment";
};
export type composerQueriesImagesMacroQueriesCategories_fragment$key = {
  readonly " $data"?: composerQueriesImagesMacroQueriesCategories_fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"composerQueriesImagesMacroQueriesCategories_fragment">;
};

import composerQueriesImagesMacroQueriesCategoriesFragmentQuery_graphql from './composerQueriesImagesMacroQueriesCategoriesFragmentQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasImages",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSystemwide",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfProducts",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referenceKey",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isLibrary"
    },
    {
      "kind": "RootArgument",
      "name": "onlybackground"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": composerQueriesImagesMacroQueriesCategoriesFragmentQuery_graphql
    }
  },
  "name": "composerQueriesImagesMacroQueriesCategories_fragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isLibrary",
          "variableName": "isLibrary"
        },
        {
          "kind": "Variable",
          "name": "onlybackground",
          "variableName": "onlybackground"
        }
      ],
      "concreteType": "ImageMacroCategory",
      "kind": "LinkedField",
      "name": "imageMacroCategories",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        (v1/*:: as any*/),
        (v2/*:: as any*/),
        (v3/*:: as any*/),
        (v4/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "onlyForBackgrounds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "macroCategoryPosition",
          "storageKey": null
        },
        (v5/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageCategory",
          "kind": "LinkedField",
          "name": "categories",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            (v4/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "categoryPosition",
              "storageKey": null
            },
            (v5/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "ffcb9081aa963c7df2ece2f406643d10";

export default node;
